import React from "react";
import Image, { type ImageProps } from "next/image";

/**
 * A Next image that fills the entire space of the container.
 */
export function FillImage(props: ImageProps) {
  return <Image fill sizes="100%" placeholder="blur" {...props} />;
}
